import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  LayoutDashboard,
  ClipboardList,
  DollarSign,
  Phone,
  Menu
} from 'lucide-react';

export default function MobileBottomBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  // Don't show for coaches (they have standalone dashboard)
  if (!user || user.role === 'coach') {
    return null;
  }

  const tabs = [
    {
      icon: LayoutDashboard,
      label: 'Dashboard',
      path: '/',
      roles: ['admin', 'standard_user', 'super_admin']
    },
    {
      icon: ClipboardList,
      label: 'EOD Sales',
      path: '/eod/new',
      roles: ['admin', 'standard_user', 'super_admin']
    },
    {
      icon: Phone,
      label: 'EOD Calls',
      path: '/eod/callcenter',
      roles: ['admin', 'standard_user', 'super_admin']
    },
    {
      icon: DollarSign,
      label: 'Sale',
      path: '/sales/new',
      roles: ['admin', 'standard_user', 'super_admin']
    },
    {
      icon: Menu,
      label: 'More',
      path: '/settings',
      roles: ['admin', 'standard_user', 'super_admin']
    }
  ];

  const visibleTabs = tabs.filter(tab => tab.roles.includes(user.role));

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <div
      className="lg:hidden fixed bottom-0 left-0 right-0 z-50 border-t"
      style={{
        background: 'rgba(13, 21, 38, 0.95)',
        backdropFilter: 'blur(12px)',
        borderColor: 'rgba(255,255,255,0.1)',
        boxShadow: '0 -4px 24px rgba(0,0,0,0.4)'
      }}
    >
      <div className="flex items-center justify-around px-2 py-2">
        {visibleTabs.map((tab) => {
          const Icon = tab.icon;
          const active = isActive(tab.path);
          
          return (
            <button
              key={tab.path}
              onClick={() => navigate(tab.path)}
              className="flex flex-col items-center justify-center gap-1 py-2 px-3 rounded-lg transition-all active:scale-95 min-w-[64px]"
              style={{
                background: active ? 'rgba(37,99,235,0.15)' : 'transparent',
                border: active ? '1px solid rgba(37,99,235,0.3)' : '1px solid transparent'
              }}
              data-testid={`mobile-tab-${tab.label.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <Icon
                size={20}
                style={{
                  color: active ? '#60A5FA' : 'rgba(148,163,184,0.7)',
                  strokeWidth: active ? 2.5 : 2
                }}
              />
              <span
                className="text-xs font-medium"
                style={{
                  color: active ? '#60A5FA' : 'rgba(148,163,184,0.6)',
                  fontWeight: active ? 600 : 500
                }}
              >
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
      
      {/* Safe area spacing for iOS devices */}
      <div className="h-safe-area-inset-bottom" style={{ height: 'env(safe-area-inset-bottom, 0px)' }} />
    </div>
  );
}
